/**
 * Where a block's hover controls sit. One flag per class, so a host binds them
 * with `[class.row-controls]="…"` instead of receiving a joined string it would
 * have to trust and re-split.
 *
 * Produced by `default-block-view`, which is the only component that can measure
 * the rendered box; every block host reads it off {@link BaseBlockComponent}.
 */
export type ItemControlsPlacement = {
    /** The block is too shallow, or full-bleed, to hold the controls inside it. */
    rowControls: boolean;
    basicControlsPosition: boolean;
    smallTopIndent: boolean;
    smallBottomIndent: boolean;
    bottomInnerControlsPosition: boolean;
    bottomOuterControlsPosition: boolean;
};

/** A block whose view has not measured itself yet, and every host that has no view. */
export const NO_ITEM_CONTROLS: ItemControlsPlacement = {
    rowControls: false,
    basicControlsPosition: false,
    smallTopIndent: false,
    smallBottomIndent: false,
    bottomInnerControlsPosition: false,
    bottomOuterControlsPosition: false,
};
